var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import firebase from "firebase/app";
import { defaultCoverImages, onEmulator, reportDebug, reportError, reportInfo } from "..";
import { DropDownMode } from "../components/common/Dropdown";
import { firebaseConfig, firebaseConfigTest } from "../resources/configs";
import { mergeAppConfigs } from "./appConfigs";
import { narrowPage, normalPage } from "./dataTypes";
require("firebase/remote-config");
export var configParameters;
(function (configParameters) {
    configParameters["resolveDelay"] = "query_resolve_delay_millis";
    configParameters["coverImages"] = "cover_images_prod";
    configParameters["dropdownMode"] = "mode_dropdown_picker";
    configParameters["allowDynamicTheme"] = "theme_dynamic";
})(configParameters || (configParameters = {}));
export var remoteConfig = function (app) { return app ? app.remoteConfig() : firebase.remoteConfig(firebase.app()); };
var configObservers = [];
var hasInit = false;
var configVersion = 0;
export function initHashimukh(configuration) {
    return __awaiter(this, void 0, void 0, function () {
        var logcatApp, rConfig, activateFetchedPromise;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (hasInit)
                        return [2];
                    hasInit = true;
                    logcatApp = firebase.initializeApp(onEmulator ? firebaseConfigTest : firebaseConfig);
                    rConfig = remoteConfig(logcatApp);
                    if (onEmulator) {
                        rConfig.settings.minimumFetchIntervalMillis = 300000;
                    }
                    rConfig.defaultConfig = (_a = {},
                        _a[configParameters.resolveDelay] = 650,
                        _a[configParameters.coverImages] = JSON.stringify(defaultCoverImages),
                        _a[configParameters.dropdownMode] = DropDownMode.RESPONSIVE,
                        _a[configParameters.allowDynamicTheme] = false,
                        _a);
                    activateFetchedPromise = rConfig.activate();
                    rConfig.fetchAndActivate()
                        .then(function (value) {
                        if (value) {
                            reportInfo("Remote config activated with new values");
                            configVersion++;
                        }
                        else {
                            reportInfo("Remote config already activated");
                        }
                        configObservers.forEach(function (observer) {
                            observer(configVersion);
                        });
                    })
                        .catch(function (err) {
                        reportError("Error fetch and activating remote config", err);
                    });
                    if (configuration)
                        mergeAppConfigs(configuration);
                    return [4, activateFetchedPromise];
                case 1:
                    _b.sent();
                    return [2];
            }
        });
    });
}
export function observerConfig(observer) {
    if (configObservers.indexOf(observer) === -1) {
        configObservers.push(observer);
    }
    else {
        reportDebug(function () { return "Observer already added; skipping operation"; });
    }
}
export function removeConfigObserver(observer) {
    var index = configObservers.indexOf(observer);
    if (index !== -1) {
        configObservers.splice(index, 1);
    }
}
export function copyToClipboard(text) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!navigator.clipboard) return [3, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, navigator.clipboard.writeText(text)];
                case 2:
                    _a.sent();
                    reportDebug(function () { return "Text copied to clipboard"; });
                    return [2, true];
                case 3:
                    error_1 = _a.sent();
                    reportError("Failed to copy text to clipboard via navigator", error_1);
                    return [2, copyToClipboardFallback(text)];
                case 4: return [3, 6];
                case 5: return [2, copyToClipboardFallback(text)];
                case 6: return [2];
            }
        });
    });
}
function copyToClipboardFallback(text) {
    var textElement = document.createElement('textarea');
    textElement.value = text;
    textElement.style.top = "0";
    textElement.style.left = "0";
    textElement.style.position = "fixed";
    document.body.appendChild(textElement);
    textElement.focus();
    textElement.select();
    var success = false;
    try {
        var successful = document.execCommand("copy");
        if (successful) {
            reportDebug(function () { return "Text copied to clipboard"; });
            success = true;
        }
        else {
            reportError("Failed to copy text to clipboard");
        }
    }
    catch (error) {
        reportError("Failed to copy text to clipboard", error);
    }
    document.body.removeChild(textElement);
    return success;
}
export function dotNotation(field) {
    var moreFields = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        moreFields[_i - 1] = arguments[_i];
    }
    var res = field;
    moreFields.forEach(function (value) {
        res = res.concat(".").concat(value);
    });
    return res;
}
export function getPageProps(type) {
    if (type === 'normal' || !type) {
        return normalPage;
    }
    else if (type === 'narrow') {
        return narrowPage;
    }
    else {
        return type;
    }
}
export function copyProps(from, to) {
    return Object.assign(to, from);
}
export function isValidEmail(email) {
    return email.length < 255 && /^[\S]+@[\S]+\.[^.,/]{1,}$/gi.test(email);
}
//# sourceMappingURL=common.js.map